import React, { useContext } from "react";
import { GlobalDataContext } from "../context/context";
import TransparentHeader from "../components/global/TransparentHeader";
import BaseLayout from "../components/global/BaseLayout";
import ContentReviews from "../components/reviews/ContentReviews";


function Reviews() {
  const { rpdata } = useContext(GlobalDataContext);

  return (
    <BaseLayout PageName="Reviews">
      <div className="md:max-w-full w-full">
        <TransparentHeader
          headertitle="Reviews"
          Subheader="Reviews"
          bgimg={`${rpdata?.gallery?.[10]}`}
        />
      </div>
      <div className="w-[90%] md:w-4/5 mx-auto py-[100px]">
        <h1 className="text-center pb-4">
          {rpdata?.labels?.general?.titleReviews}
        </h1>
        {/* <div className={`${rpdata?.reviews?.links?.[0]}`}></div> */}

        <div className="w-full flex md:flex-col justify-between self-center items-center my-4">

        </div>
        <ContentReviews />
      </div>

    </BaseLayout>
  );
}

export default Reviews;
